const TYPES = {
  C: 'C Corp',
  S: 'S Corp',
  L: 'LLC Single Ownership',
  K: 'LLC Partnership',
  F: 'Foreign',
};

const parse = type => {
  if (TYPES[type]) {
    return TYPES[type];
  }
  return type || '';
};

module.exports = parse;
